import { Component, ChangeDetectionStrategy, input } from '@angular/core';

@Component({
    selector: 'warema-headline',
    templateUrl: './headline.component.html',
    styleUrls: ['./headline.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeadlineComponent {
    public readonly headline = input('');
}
